import { Link } from "react-router-dom";

function CostPrice() {
  return (
    <div className="p-4 min-h-screen">
      <header className="flex items-center gap-4 mb-6">
        <h2 className="text-xl font-bold">Stock Value Cost Price</h2>
      </header>

      <div className="bg-white rounded-lg shadow-lg p-4 mb-4">
        <div className="text-primary font-bold text-lg mb-4">Total Value: $00.00</div>

        <div className="grid gap-4">
          {[...Array(10)].map((_, index) => (
            <div
              key={index}
              className="bg-gray-50 p-4 rounded-lg shadow flex flex-row items-center sm:justify-between gap-2"
            >
              <span className="text-sm font-semibold">Water Bottle 1L</span>
              <span className="text-xs md:text-sm font-medium text-gray-600">
                $0.00 × 0 = $0.00
              </span>
              <span className="text-xs md:text-sm text-primary mt-2 sm:mt-0">Tracker Not Active</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CostPrice;
